import * as React from "react";
import InputUnstyled from "@mui/base/InputUnstyled";
import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";
import { TextField } from "@mui/material";

const blue = {
  100: "#DAECFF",
  200: "#80BFFF",
  400: "#3399FF",
  600: "#0072E5",
};

const grey = {
  50: "#F3F6F9",
  100: "#E7EBF0",
  200: "#E0E3E7",
  300: "#CDD2D7",
  400: "#B2BAC2",
  500: "#A0AAB4",
  600: "#6F7E8C",
  700: "#3E5060",
  800: "#2D3843",
  900: "#1A2027",
};

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    display: "flex",

    justifyContent: "center",
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > div > input": {
      padding: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
}));

const StyledInputElement = styled("input")(
  ({ theme }) => `
  width: 30px;
  justifyContent: left;
  alignItems: center;
  display: flex;
  padding: 0px 0px ;
  font-size: 0.875rem;
  font-family: IBM Plex Sans, sans-serif;
  font-weight: 400;
  line-height: 1.5;
 
  text-align: center;
  alignSelf: center;

 
`
);

const CustomInput = React.forwardRef(function CustomInput(props, ref) {
  const classes = useStyles();
  return (
    <InputUnstyled
      className={classes.inputRoot}
      components={{ Input: StyledInputElement }}
      {...props}
      onChange={props.onChange}
      ref={ref}
    />
    // <TextField
    //   className={classes.inputRoot}
    //   components={{ Input: StyledInputElement }}
    //   {...props}
    //   onChange={props.onChange}
    //   ref={ref}
    //   id="outlined-basic"
    //   label=""
    //   variant="outlined"
    // />
  );
});

export default function UnstyledInputBasic({ value, onChange }) {
  return (
    <CustomInput aria-label="Demo input" value={value} onChange={onChange} />
  );
}
